var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonLockBlueSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "uq2pa",
    d: "M932.5 177h-.5v-.5c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5v.5h-.5a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5zm-6.5-.5c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5v.5h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uq2pb",
    d: "M923 177.5c0-.659.427-1.22 1.02-1.421a4.507 4.507 0 0 1 2.72-3.716 9.5 9.5 0 0 0-3.862-2.05A4.497 4.497 0 0 0 925 166.5c0-2.482-2.019-4.5-4.5-4.5a4.505 4.505 0 0 0-4.5 4.5c0 1.608.85 3.018 2.122 3.813-4.089 1.06-7.122 4.771-7.122 9.187a.5.5 0 0 0 .5.5H923z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uq2pc",
    d: "M927.09 176h2.236a9.36 9.36 0 0 0-.436-.946 1.49 1.49 0 0 0-.386-.054c-.652 0-1.207.418-1.414 1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-911 -162)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#uq2pa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#uq2pb"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#1f76ff",
    xlinkHref: "#uq2pc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonLockBlueSmall);
export default __webpack_public_path__ + "static/media/person-lock-blue-small.27fffb232a89fcbda5ad15ee16a64db2.svg";
export { ForwardRef as ReactComponent };